import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ComputerGamePage, ComputerGamePageProps } from '@features/game/pages/ComputerGamePage';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

const querySchema = z.object({
  elo: z.number().optional(),
  color: z.enum(['white', 'black', 'alternate']).optional(),
  mode: z.enum(['settings', 'positions', 'random', 'play']).optional(),
  time: z.number().optional(),
  'time-add': z.number().optional(),
});

export const Route = createFileRoute('/game/computer')({
  component: Page,
  validateSearch: querySchema,
});

function Page() {
  const search = Route.useSearch();
  const { elo, color, mode, time: timeInitial } = search;
  const timeAdd = search['time-add'];

  const time: ComputerGamePageProps['time'] = timeInitial
    ? { initial: timeInitial, perMove: timeAdd ?? 0 }
    : undefined;

  return (
    <ComputerGamePage
      avatar={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget alwaysRound />
        </>
      }
      elo={elo}
      color={color}
      time={time}
      mode={mode}
    />
  );
}
